/**
 * 画布编辑器引导步骤配置
 */
import React from 'react';

/**
 * 常规编辑模式的引导步骤
 */
export const tourSteps = [
  {
    target: 'body',
    content: (
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '16px' }}>🎉 欢迎来到画布编辑器</h2>
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          这是一个可视化的 AI 工作流编排工具，<br />
          让我们用几个简单的步骤带你快速上手！
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
    styles: {
      options: {
        width: 500,
      },
    },
  },
  {
    target: '.canvas-toolbar',
    content: (
      <div>
        <h3 style={{ marginBottom: '12px' }}>📦 底部工具栏</h3>
        <p style={{ lineHeight: '1.6' }}>
          这里提供了多种节点类型：<br />
          • <strong>输入节点</strong>：文本、图片、视频、音频<br />
          • <strong>AI模型</strong>：图像生成、视频生成、音乐创作<br />
          • <strong>工具</strong>：笔记、图片展示等<br />
          <br />
          <span style={{ color: '#5f8f35' }}>💡 点击或拖拽到画布添加节点</span>
        </p>
      </div>
    ),
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '.reactflow-wrapper',
    content: (
      <div>
        <h3 style={{ marginBottom: '12px' }}>🖱️ 画布操作</h3>
        <p style={{ lineHeight: '1.6' }}>
          在画布区域可以：<br />
          • <strong>双击空白处</strong>：快速创建节点<br />
          • <strong>拖动节点</strong>：调整位置<br />
          • <strong>鼠标滚轮</strong>：缩放画布<br />
          • <strong>按住空格+拖动</strong>：平移画布<br />
          <br />
          <span style={{ color: '#5f8f35' }}>💡 试试双击画布创建第一个节点</span>
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: '.reactflow-wrapper',
    content: (
      <div>
        <h3 style={{ marginBottom: '12px' }}>🔗 连接节点</h3>
        <p style={{ lineHeight: '1.6' }}>
          通过连接节点构建工作流：<br />
          • 从节点右侧的 <strong>圆点(输出)</strong> 拖动<br />
          • 连接到另一个节点左侧的 <strong>圆点(输入)</strong><br />
          • 系统会自动验证连接是否有效<br />
          <br />
          <span style={{ color: '#5f8f35' }}>
            💡 例如：文本输入节点 → 图像生成节点
          </span>
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '.CanvasEditor-toolbar-right',
    content: (
      <div>
        <h3 style={{ marginBottom: '12px' }}>💾 保存与导出</h3>
        <p style={{ lineHeight: '1.6' }}>
          顶部工具栏右侧提供了：<br />
          • <strong>帮助按钮</strong>：随时查看引导<br />
          • <strong>保存</strong>：手动保存画布<br />
          • <strong>导出</strong>：导出为高清图片<br />
          • <strong>分享</strong>：分享给其他用户查看<br />
          <br />
          <span style={{ color: '#5f8f35' }}>✨ 大功告成！开始创作吧</span>
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
  },
];

/**
 * 只读模式的引导步骤（针对分享的项目）
 */
export const readOnlyTourSteps = [
  {
    target: 'body',
    content: (
      <div style={{ textAlign: 'center' }}>
        <h2 style={{ marginBottom: '16px' }}>👀 这是一个分享的项目</h2>
        <p style={{ fontSize: '16px', lineHeight: '1.6' }}>
          当前处于<strong>只读模式</strong>，无法直接编辑。<br />
          不过别担心，你可以复制这个项目进行修改！
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
    styles: {
      options: {
        width: 500,
      },
    },
  },
  {
    target: '.reactflow-wrapper',
    content: (
      <div>
        <h3 style={{ marginBottom: '12px' }}>🎨 浏览工作流</h3>
        <p style={{ lineHeight: '1.6' }}>
          你可以自由浏览这个画布项目：<br />
          • <strong>拖动画布</strong>：查看所有节点<br />
          • <strong>鼠标滚轮</strong>：缩放画布<br />
          • <strong>点击节点</strong>：查看节点详情<br />
          <br />
          <span style={{ color: '#5f8f35' }}>💡 感兴趣？复制后就能自己编辑了</span>
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '.CanvasEditor-clone-button',
    content: (
      <div>
        <h3 style={{ marginBottom: '12px' }}>📋 复制项目开始创作</h3>
        <p style={{ lineHeight: '1.6' }}>
          点击这个<strong>「复制项目」</strong>按钮：<br />
          • 系统会创建一个属于你的副本<br />
          • 在副本中可以自由编辑和修改<br />
          • 原项目不会受到影响<br />
          <br />
          <span style={{ color: '#5f8f35', fontWeight: 'bold' }}>
            ✨ 复制后即可开始你的创作之旅！
          </span>
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true,
    styles: {
      options: {
        width: 480,
      },
    },
  },
];

/**
 * Joyride 样式配置
 */
export const tourStyles = {
  options: {
    arrowColor: '#fff',
    backgroundColor: '#fff',
    overlayColor: 'rgba(32, 38, 34, 0.42)',
    primaryColor: '#171a17',
    textColor: '#343a35',
    width: 450,
    zIndex: 10000,
  },
  tooltip: {
    borderRadius: 14,
    padding: 22,
    boxShadow: '0 24px 70px rgba(22, 27, 23, 0.18)',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  tooltipTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 12,
  },
  tooltipContent: {
    fontSize: 14,
    lineHeight: 1.6,
  },
  buttonNext: {
    backgroundColor: '#171a17',
    borderRadius: 8,
    fontSize: 14,
    padding: '8px 16px',
  },
  buttonBack: {
    color: '#666',
    marginRight: 10,
  },
  buttonSkip: {
    color: '#999',
  },
};

/**
 * Joyride 本地化文案
 */
export const tourLocale = {
  back: '上一步',
  close: '关闭',
  last: '完成',
  next: '下一步',
  open: '打开',
  skip: '跳过',
};
